// value should match tealium event name from documentation
const rotatePromoBannerClickEvent = 'pencil banner tracking';
interface IPageName {
  [key: string]: string;
}
export const analytics_Event_Country_Constant = 'USA';
export const analytics_Event_Currency_Constant = 'USD';
export const TPageName: IPageName = {
  cart: 'cart',
  customerInfo: 'customer info',
  deliveryInfo: 'delivery info',
  paymentInfo: 'payment info',
  orderconfirmation: 'order confirmation',
};
export const domTitle: IPageName = {
  cart: 'Cart',
  customerInfo: 'Customer Info',
  deliveryInfo: 'Delivery Scheduling',
  paymentInfo: 'Payment',
  paypalExpress: 'Paypal Express',
  applePayExpress: 'Apple-Pay Express',
  orderconfirmation: 'Order Confirmation',
};
export const checkoutPageTypeAndContext = 'checkout';
interface IAnalytics_event_checkoutOption_constants {
  checkoutOptionDelivery: string[];
  checkoutOptionDirectDel: string[];
}
export const analytics_event_checkoutOption_constants: IAnalytics_event_checkoutOption_constants =
  {
    checkoutOptionDelivery: ['Delivery'],
    checkoutOptionDirectDel: ['Direct Del'],
  };
export enum ANALYTICS_EVENT {
  addRemovePromos = 'add-remove-promos',
  promotionImpression = 'promotion-impression',
  promotionClick = 'promotion-click',
  productClick = 'product-click',
  addFromCart = 'add-from-cart',
  removeFromCart = 'remove-from-cart',
  addToCart = 'add-to-cart',
  productImpression = 'product-impression',
  bottomPromo = 'home-bottom-promo',
  internalNavigation = 'internal-navigation',
  outboundSocialLinkClick = 'outbound-social-link-click',
  outboundGeneralLinkClick = 'outbound-general-link-click',
  pencilBannerTracking = 'pencil-banner-tracking',
  shoppingGuideReel = 'shopping-guide-reel',
  featuredSalesReel = 'featured-sales-reel',
  mattressMatcher = 'mattress-matcher-content-card',
  shopByDepartment = 'shop-by-department',
  footerEmailSignup = 'footer-email-signup',
  homePageFilterAction = 'D5-HP-filter-action',
  heroCarousel = 'hero-carousel',
  findStoreLinkClick = 'store-locator-sleep-expert-pick-module',
  chat = 'chat-widget-initiated',
  call = 'call-engagement',
  podium = 'podium-chat',
  search = 'site_search',
  // store locator
  storeLocatorOpen = 'store-locator-slideout-open',
  storeLocatorSearch = 'store-locator-slideout-search',
  storeLocatorSeeAll = 'store-locator-slideout-see-all-stores',
  storeLocatorMakeMyStore = 'store-locator-slideout-make-my-store',
  storeLocatorChangeMyStore = 'store-locator-slideout-change-my-store',
  storeLocatorStoreDetails = 'store-locator-slideout-store-details',
  // modals
  emailSignupModalOpen = 'popup-modal-loaded',
  emailSignupModalClose = 'close-email-signup-modal',
  emailSignupModalSubmit = 'popup-modal-email-signup',
  accessibilityLink = 'content-block',
  rotatePromoBannerClick = rotatePromoBannerClickEvent,
  sleepDisruptorsNavModule = 'sleep-disruptor-nav-module',
  // pdp
  productDetailView = 'product-detail-view',
  // Customer Info Form
  formFirstName = 'Checkout-Form-First-Name',
  formLastName = 'Checkout-Form-Last-Name',
  formEmail = 'Checkout-Form-Email-Address',
  formPhone = 'Checkout-Form-Phone',
  formEmailMeIn = 'Checkout-Form-Email-Opt-in',
  formEmailMeOut = 'Checkout-Form-Email-Opt-out',
  formAddress1 = 'Checkout-Form-Address1',
  formAddress2 = 'Checkout-Form-Address2',
  formPostal = 'Checkout-Form-Postal',
  formCity = 'Checkout-Form-City',
  formState = 'Checkout-Form-State',

  // Delivery Info form
  deliveryformDate = 'Checkout-Delivery-Change-Delivery-Date',
  deliveryFormTime = 'Checkout-Delivery-Change-Delivery-Time',
  deliveryFormWithNoDate = 'Checkout-Delivery-Change-Will-Call',
  deliveryFormFreeDeliveryServiceOption = 'Checkout-Delivery-Downgrade',
  checkoutSteps = 'checkout-steps',

  // payment info form

  paymentformCardNumber = 'Checkout-Form-Creditcard-Number',
  paymentformCardExpiry = 'Checkout-Form-Creditcard-ExpiryDate',
  paymentformCardCode = 'Checkout-Form-Creditcard-Code',
  paymentformBillingCheckbox = 'Checkout-Check-Box-UseAs-BillingAddress',
  paymentFormCreditCardRadio = 'Checkout-Radio-Button-Credit/Debit Card',
  paymentformPaypalRadio = 'Checkout-Radio-Button-Paypal',
  paymentformSynchronyRadio = 'Checkout-Radio-Button-Synchrony',
  paymentformAffirmRadio = 'Checkout-Radio-Button-Affirm',
  paymentformSynchronyPrequalify = 'PymtStep-Synchrony-Prequalify',
  paymentformSynchronyModalPrequalify = 'PDP-Synchrony-Prequalify',
  paymentformSynchronyApply = 'apply-now-synchrony-wmap',
  paymentformSynchronyLearnHow = 'internal-navigation-payment-synchrony',
  paymentformProgressiveRadio = 'Checkout-Radio-Button-Progressive',
  paymentformProgressiveApply = 'Payment-Progressive-Apply',

  drawerSynchronyPrequalify = 'prequalify-synchrony-cart page',
  drawerSynchronyApply = 'apply-now-synchrony-cart page',

  // order confirmation
  angiButtonLink = 'angi-button-link-click',
}
export enum ANALYTICS_EVENT_TYPE {
  // (Continue buttons) steps event type
  viewOrder = 'view cart',
  customerInfo = 'InitiateCheckout',
  deliveryInfo = 'AddDeliveryInfo',
  payment = 'AddPaymentInfo',
  submitOrder = 'SubmitOrder',
  chatClick = 'chat_click',
  callClick = 'call_engagement',
}
export enum ANALYTICS_EVENT_CHECKOUT_STEPS {
  // (Continue buttons) steps event type
  viewOrder = '1',
  customerInfo = '2',
  deliveryInfo = '3',
  payment = '4',
  submitOrder = '5',
}

export enum ANALYTICS_EVENT_LABEL {
  // Customer Info Form
  formFirstName = 'First_Name',
  formLastName = 'Last_Name',
  formEmail = 'Email_Address',
  formPhone = 'Address_Phone',
  formEmailMeIn = 'Email Opt in',
  formEmailMeOut = 'Email Opt Out',
  formAddress1 = 'Address_Address1',
  formAddress2 = 'Address_Address2',
  formPostal = 'Address_Postal',
  formCity = 'Address_City',
  formState = 'Address_State',
  // Delivery Info Form
  deliveryform = 'Delivery Page',

  // payment info form
  paymentformCardNumber = 'Creditcard_Number',
  paymentformCardExpiry = 'Creditcard_ExpiryDate',
  paymentformCardCode = 'Creditcard_Code',
  paymentformBillingCheckbox = 'UseAs_BillingAddress',
  paymentFormCreditCardRadio = 'Pay With Credit/Debit Card',
  paymentformPaypalRadio = 'Pay With Paypal',
  paymentformSynchronyRadio = 'SynchronyFinancial',
  paymentformAffirmRadio = 'AffirmFinancial',
  paymentformSynchronyPrequalify = 'Synchrony - Prequalify Now',
  paymentformSynchronyLearnHow = 'from Payment Financing Per Month “Learn How” link',
  paymentformSynchronyApply = 'Synchrony - Apply Now',
  paymentformProgressiveRadio = 'ProgressiveLeaseToOwn',
  paymentformProgressiveApply = 'Progressive - Apply Now',
  paymentformProgressiveApplyDialogue = 'Progressive - Apply Now from Learn More box',

  // chat
  chatClick = 'chat engagement',
  callClick = 'call engagement',
  // (Continue buttons) steps labels
  viewOrder = 'Step 1 : View Order',
  customerInfo = 'Step 2 : Customer Info',
  deliveryInfo = 'Step 3 : Delivery Info',
  payment = 'Step 4 : Payment Info',
  submitOrder = 'Step 5 : Submit Order',

  // Order Confirmation
  orderconfirmationAngiLinkLabel = 'from Angi Schedule Assembly button: ',
  drawerSynchronyApplyandPrequalify = 'financing',
}

export enum ANALYTICS_EVENT_ACTION {
  // Delivery Info form
  deliveryformDate = 'Change Delivery Date',
  deliveryFormTime = 'Change Delivery Time',
  deliveryFormWithNoDate = 'Will Call - No Delivery Date',
  deliveryFormFreeDeliveryServiceOption = 'Downgrade Delivery to Silver',

  // Payment Info Form
  paymentformProgressiveSynchronyApply = 'Payment page Apply Now button click',
  paymentformSynchronyPrequalify = 'PymtStep Prequal Now button click',
  paymentformSynchronyLearnHow = 'to: Synchrony Financing Per Month modal',
  paymentformPaymentMethod = 'Radio Button',

  // Order Confirmation
  orderconfirmationAngiLink = 'to: https://partnerships.handy.com/mattressfirm/',
  drawerSynchronyApply = 'click synchrony apply now btn',
  drawerSynchronyPrequalify = 'click synchrony prequalify btn',
  drawerSynchronyChatCallClick = 'click from synchrony financing cart page',
}

// value should match tealium category name from documentation
export enum ANALYTICS_EVENT_CATEGORY {
  internalLinks = 'internal links',
  outboundLinks = 'outbound links',
  ecommerce = 'ecommerce',
  addRemovePromos = 'add/remove promos',
  bottomPromo = 'home bottom promo',
  pencilBannerTracking = 'pencil banner tracking',
  shoppingGuideReel = 'shopping guide reel',
  featuredSalesReel = 'featured sales reel',
  mattressMatcher = 'mattress matcher content card',
  shopByDepartment = 'shop-by-department',
  emailSignup = 'email signup tracking',
  homePageFilterAction = 'D5 HP Filter Action',
  heroCarousel = 'hero carousel',
  findStoreLinkClick = 'Store Locator',
  chat = 'chat',
  call = 'call',
  podium = 'Webchat Widget',
  storeLocator = 'store locator slideout',
  accessibilityLink = 'Accessibility Information container',
  rotatePromoBannerClick = rotatePromoBannerClickEvent,
  sleepDisruptorsNavModule = 'sleep disruptor nav module',
  checkout = 'Checkout',
  financing = 'Financing',
  applyNow = 'link-apply now wmap page',
  drawerSynchronyApplyandPrequalify = 'link-financing & leasing options modal cart page',
}
export interface TealiumEventData {
  [key: string]: string | number;
}

interface SynchronyChatButtonData {
  event: ANALYTICS_EVENT;
  event_category: ANALYTICS_EVENT_CATEGORY;
  event_action: string | number;
  event_label: string;
  event_type?: string;
  enhanced_action?: string;
  event_noninteraction?: 'true' | 'false';
  product_id?: string[];
  product_name?: string[];
  product_category?: string[];
  product_brand?: string[];
  product_variant?: string[];
  product_price?: string[];
  product_quantity?: string[];
}

interface EventProductClick {
  event: ANALYTICS_EVENT.productClick;
  event_category: ANALYTICS_EVENT_CATEGORY;
  event_action: string | number;
  event_label: string;
  event_noninteraction: 'true' | 'false';
  enhanced_action: string;
  product_id: string[];
  product_position: number[] | string[];
  product_name: string[];
  product_list_name: string[];
  product_category: string[];
  product_brand: string[];
  product_variant: string[];
  unbxd_page_type?: string;
  unbxd_experience_widget?: string;
  d365_product_id?: string[];
  d365_product_variant?: string[];
}
interface EventPhoneClick {
  event: ANALYTICS_EVENT;
  event_category: ANALYTICS_EVENT_CATEGORY;
  event_noninteraction: 'true' | 'false';
  event_action: string | number;
  event_label: string;
  event_type: string;
}
interface EventChatClick {
  event: ANALYTICS_EVENT;
  event_category: ANALYTICS_EVENT_CATEGORY;
  event_noninteraction: 'true' | 'false';
  event_action: string | number;
  event_label: string;
  event_type: string;
}
interface EventProductImpression {
  event: ANALYTICS_EVENT.productImpression;
  event_category: ANALYTICS_EVENT_CATEGORY.ecommerce;
  event_action: string;
  event_label: string;
  event_noninteraction: 'true' | 'false';
  product_impression_list_name: string[];
  product_impression_position: number[];
  product_impression_id: string[];
  product_impression_name: string[];
  product_impression_price: number[];
  product_impression_brand: (string | null | undefined)[];
  enhanced_action: string;
  unbxd_page_type?: string;
  unbxd_experience_widget?: string;
  d365_product_id?: string[];
  d365_product_variant?: string[];
}

interface EventContinueShopping {
  event: ANALYTICS_EVENT.internalNavigation;
  event_action: string | number;
  event_category: ANALYTICS_EVENT_CATEGORY;
  event_label: string;
  event_noninteraction: 'true' | 'false';
}

interface EventPromoCodeAddRemove {
  event: ANALYTICS_EVENT.addRemovePromos;
  event_category: ANALYTICS_EVENT_CATEGORY.addRemovePromos;
  event_action: string | number;
  event_label: string;
  event_noninteraction: 'true' | 'false';
}
interface EventQuantityIncrease {
  event: ANALYTICS_EVENT.addFromCart;
  enhanced_action: string;
  event_action: string | number;
  event_category: ANALYTICS_EVENT_CATEGORY;
  event_label: string;
  event_noninteraction: 'true' | 'false';
  product_id: string[];
  product_name: string[];
  product_category: string[];
  product_brand: string[];
  product_variant: string[];
  product_price: string[];
  product_quantity: string[];
}
interface EventRemoveFromCart {
  event: ANALYTICS_EVENT.removeFromCart;
  enhanced_action: string;
  event_action: string | number;
  event_category: ANALYTICS_EVENT_CATEGORY;
  event_label: string;
  event_noninteraction: 'true' | 'false';
  product_id: string[];
  product_name: string[];
  product_category: string[];
  product_brand: string[];
  product_variant: string[];
  product_price: string[];
  product_quantity: string[];
}
interface EventCustomerInforForm {
  event: IANALYTICS_EVENT_PROPERTY;
  event_action: string | number;
  event_category: ANALYTICS_EVENT_CATEGORY;
  event_label: string;
  event_noninteraction: 'true' | 'false';
}

interface EventProgressiveApply {
  event: IANALYTICS_EVENT_PROPERTY;
  event_action: string | number;
  event_category: ANALYTICS_EVENT_CATEGORY;
  event_label: string;
  event_noninteraction: 'true' | 'false';
  event_type: string | undefined;
}

interface EventCartSteps {
  event: ANALYTICS_EVENT.checkoutSteps;
  event_category: ANALYTICS_EVENT_CATEGORY.ecommerce;
  event_action: string | number;
  event_label: string;
  event_noninteraction: 'true' | 'false';
  enhanced_action: string;
  event_type: string;
  checkout_step: string;
  product_id: (string | undefined)[];
  product_name: (string | undefined)[];
  product_category: (string | undefined)[];
  product_brand: (string | undefined)[];
  product_variant: (string | undefined)[];
  product_price: (string | undefined)[];
  product_quantity: (string | undefined)[];
  product_size: (string | undefined)[];
  product_url: (string | undefined)[];
  product_image_url: (string | undefined)[];
  core_item_flag: string;
  funnel_type: string;
  ga_title?: string; // for step 2, 3 and 4
  ga_location?: string; // for step 2, 3 and 4
  checkoutOption?: string[]; // for step 4
}

// END App Event declarations

export type EventWithPayload =
  | EventContinueShopping
  | EventProductClick
  | EventProductImpression
  | EventQuantityIncrease
  | EventRemoveFromCart
  | EventCustomerInforForm
  | EventProgressiveApply
  | SynchronyChatButtonData
  | EventCartSteps
  | EventPromoCodeAddRemove
  | EventPhoneClick
  | EventChatClick;

// | SynchronyChatButtonData;

export type IANALYTICS_EVENT_PROPERTY =
  | ANALYTICS_EVENT.chat
  | ANALYTICS_EVENT.paymentformProgressiveRadio
  | ANALYTICS_EVENT.paymentformProgressiveApply
  | ANALYTICS_EVENT.paymentformBillingCheckbox
  | ANALYTICS_EVENT.paymentFormCreditCardRadio
  | ANALYTICS_EVENT.paymentformPaypalRadio
  | ANALYTICS_EVENT.paymentformSynchronyRadio
  | ANALYTICS_EVENT.paymentformAffirmRadio
  | ANALYTICS_EVENT.paymentformSynchronyPrequalify
  | ANALYTICS_EVENT.paymentformSynchronyModalPrequalify
  | ANALYTICS_EVENT.paymentformSynchronyApply
  | ANALYTICS_EVENT.paymentformSynchronyLearnHow
  | ANALYTICS_EVENT.paymentformCardNumber
  | ANALYTICS_EVENT.drawerSynchronyPrequalify
  | ANALYTICS_EVENT.drawerSynchronyApply
  | ANALYTICS_EVENT.paymentformCardExpiry
  | ANALYTICS_EVENT.paymentformCardCode
  | ANALYTICS_EVENT.deliveryformDate
  | ANALYTICS_EVENT.deliveryFormTime
  | ANALYTICS_EVENT.deliveryFormWithNoDate
  | ANALYTICS_EVENT.deliveryFormFreeDeliveryServiceOption
  | ANALYTICS_EVENT.formAddress1
  | ANALYTICS_EVENT.formAddress2
  | ANALYTICS_EVENT.formCity
  | ANALYTICS_EVENT.formEmail
  | ANALYTICS_EVENT.formFirstName
  | ANALYTICS_EVENT.formLastName
  | ANALYTICS_EVENT.formPhone
  | ANALYTICS_EVENT.formPostal
  | ANALYTICS_EVENT.formState
  | ANALYTICS_EVENT.formEmailMeIn
  | ANALYTICS_EVENT.formEmailMeOut
  | ANALYTICS_EVENT.internalNavigation;
